import Link from '@mui/material/Link';
import type { ReactNode } from 'react';

export function CreativeDetailsLink({
  creativeId,
  accountIds,
}: {
  creativeId: string;
  accountIds: readonly number[];
}): ReactNode {
  if (!creativeId || creativeId === '-') return null;

  const accounts = accountIds.length ? `?accounts=${encodeURIComponent(accountIds.join(','))}` : '';
  const href = `${window.location.origin}/creatives/${encodeURIComponent(creativeId)}/info${accounts}`;

  return (
    <Link
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="View creative"
      sx={{
        display: 'none',
        fontSize: 9,
        fontWeight: 600,
        color: 'primary.main',
        textDecoration: 'underline',
        '@media print': { display: 'inline' },
      }}
    >
      View creative ↗
    </Link>
  );
}
